<script>
export default {
    data() {
        return {      
            links: [ 
                {componentName: 'saleHome', title: 'Till Toppen' },
                {componentName: 'saleCost', title: 'Våra produkter', scrollId: 'our_products' },
                {componentName: 'saleExample', title: 'Skapat med JAMII', scrollId: 'created_with_jamii' },
            ],
            email: '',
            emailSent: false
        }
    },
    methods:
    {
        goTopage(link)
        {
            if (link.scrollId) {
                const element = document.getElementById(link.scrollId);
                if (element) {
                window.scrollTo({
                    top: element.offsetTop - 100, // Adjust offset as needed for fixed header
                    behavior: 'smooth'
                });
                }
            } else {
                $(window).scrollTop(0);   
                this.$router.push({ name: link.componentName })
            }
        },
        knowMore() {
            if(this.email != '')
            {
                var self = this;
                this.$communicator.post("more-info/", { email: this.email})
                    .then(function(data) {
                        self.email = '';
                        self.emailSent= true;
                    })
                    .fail(function(error) {
                        // Handle error
                    }); 
            }
        }
    }
}
</script>
<template>
<section>
    <div v-if="!emailSent">
        <h2>Vill du veta mer om jamii och våra produkter?<span> Skriv in din e-mail så hör vi av oss</span></h2>
        <div class="news_letter_area">
            <input v-model="email"  placeholder="Skriv in din email-adress"/>
            <button id="subscribe_btn"  @click="knowMore">Prenumerera</button>
            <button id="subscribe_mob_btn" @click="knowMore"><i class="fa-solid fa-paper-plane"></i></button>
        </div>
    </div>
    <div v-else>
        <h2>Tack, vi hörs!</h2>
    </div>
    <hr />
    <div class="links_area">
        <div class="about">
            <img src="@/assets/imgs/sale/new_logo_wheat.png" style="margin: -15px 0px 7px 0px;"><br>
            <p>
                Jamii utvecklas av FOOGLER AB som består av två hurtbullar med känsla för tycke och smak.
                Grundidé: Kul, prisvärt och lätt att använda. Resultat: Kul, för billigt och helt ok att använda.
                Hoppa på tåget om du och din förening, eller verksamhet, vill ha kul samt känna att man gör något prisvärt. <br>
                Skicka ett mail till <a href="mailto: admin@jamii.se" >admin@jamii.se</a> om det är något ni undrar över.
            </p>
            <br>
            <img src="@/assets/imgs/sale/smaland.png"><br>
            Product of Småland
        </div>
        <div>
            <h4>JAMII</h4>
            <ul>              
                 <li v-for="link in links" @click="goTopage(link)">
                    {{  link.title }}
                </li>  
               
            </ul>
        </div>
        <div>
            <h4>VÅRA PRODUKTER</h4>
            <ul>
                <li @click="goTopage(links[1])"><img src="@/assets/imgs/sale/new_logo_wheat.png"> Jante</li>
                <li @click="goTopage(links[1])"><img src="@/assets/imgs/sale/new_logo_wheat.png"> Lagom</li>
                <li @click="goTopage(links[1])"><img src="@/assets/imgs/sale/new_logo_wheat.png"> Märkvärdig</li>
            </ul>
        </div>
        
    </div>
</section>
</template>


<style scoped>
.links_area {
width: 80%;
margin: auto;
margin-top: 80px;
display: flex;
justify-content: center;
color: #99aca8;
text-align: left;
}
.links_area a { color: #99aca8; font-weight: 500; }

.links_area img {
    opacity: 0.6;
    width: 50%;
    max-width: 150px;
}

.links_area div{
    width: 30%;
  
}

.links_area .about {
    width: 40%;
  
}

.links_area .about p {
    margin-right: 40px;
  
}

.links_area ul {
    list-style: none;
    padding: 0px;
    margin: 0px 5px;
    font-size: 13pt;
    font-weight: 400;
}

.links_area li {
    margin-bottom: 3px;
    cursor:pointer;
}

.links_area li:hover {
    text-decoration: underline;
}

.links_area ul img {
    width: 70px !important;
    margin-bottom: -10px;
}

.news_letter_area {
    background-color: #032e24;
    width: 60%;
    max-width: 875px;
    height: 82px;
    margin: auto;
    margin-top: 46px;
    border-radius: 40px;
    border: 2px solid #4d776d;
    overflow:hidden;
    
}

#subscribe_btn {
   float:right;
   background-color: #f2c62f;
   font-family: "Poppins", sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 13pt;
    color: #032e24;
    padding: 28px 4vw;
    margin-right: -1px;
    margin-top: -1px;
   
}

#subscribe_mob_btn {        
        display: none;  
    }
.news_letter_area input {
    width: 50%;
    margin: 15px 0px 15px -10px;
    border: 0px;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    background-color: #032e24;
    color: white;
    font-size: 12pt;
     outline: none;
}
section {
    padding: 100px 0px;
    background-image: url('@/assets/imgs/sale/footer_bg.jpg');
    background-size: cover;
    text-align: center;
}

h2 {
    font-family: "Barlow Condensed", serif;
    font-weight: 600;
    font-style: normal;
    font-size: 4.7vw;
    margin-bottom:22px;
    text-transform: none;
    color: white;
}

h2 span {
    display: block;
}

h4 {
    margin: 0px 0px 40px 10px;
    color: #3c6a53;
    font-size: 15pt;
}

hr {
    width: 80%;
    margin: auto;
    margin-top: 80px;
    border: 4px solid #2d4f3e;
}

/* Responsive */
@media (max-width: 800px) {
    .links_area {
        flex-direction: column;
    }

    .links_area div{
        width: 100%;
    
    }

    
    .links_area .about {
        width: 100%;
        text-align: justify;
    
    }

    .links_area .about p {
        margin-right: 0px;
    
    }

    h4 {
        margin:30px 0px 10px 0px
    }

    h2 {
        font-size: 6vw;
        margin: 0px 10px;
    }

    h2 span {
    display:contents;
    }

    .news_letter_area {
    background-color: #032e24;
    width: 90%;
    height: 70px;
    margin: auto;
    margin-top: 46px;
    border-radius: 40px;
    border: 2px solid #4d776d;
    overflow:hidden;
    position:relative;
    
}

.news_letter_area input {
    width: 70%;
    margin: 10px 0px 10px -50px;
    border: 0px;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    background-color: #032e24;
    color: white;
    font-size: 12pt;
}
    #subscribe_btn {        
        display: none;  
    }

    #subscribe_mob_btn { 
        display: block;       
        position:absolute;
        right: -1px;
        top: -1px;
        background-color: #f2c62f;
        font-family: "Poppins", sans-serif;
        font-weight: 500;
        text-transform: uppercase;
        font-size: 13pt;
        color: #032e24;
        padding: 24px 30px 24px 30px;
    }
}

@media only screen and (min-width: 1980px) {
  h2 {
    font-size: 60pt;
  }
}
</style>